<form [formGroup]="paginationForm">
  <div class="pagination-container">
    <div class="pagination-side-icon" (click)="pagination.has_previous_page ? setCurrentPage(1) : $event.stopPropagation()">
      <i class="fa fa-lg fa-angle-double-left"></i>
    </div>
    <div class="pagination-inside-icon" (click)="pagination.has_previous_page ? setCurrentPage(pagination.current_page, '-') : $event.stopPropagation()">
      <i class="fa fa-lg fa-angle-left"></i>
    </div>
    <div class="input-group-pagination">
      <label for="lblPaginationComponent" class="label-pagination">
        <input id="lblPaginationComponent" type="text" class="form-control form-control-sm input-pagination" formControlName="current_page" [(ngModel)]="pagination.current_page"
          [ngClass]="{'is-invalid': paginationForm.controls['current_page'].invalid && paginationForm.controls['current_page'].dirty}"
          integers> de {{ pagination.last_page }}
      </label>
    </div>
    <div class="pagination-inside-icon" (click)="pagination.has_next_page ? setCurrentPage(pagination.current_page, '+') : $event.stopPropagation()">
      <i class="fa fa-lg fa-angle-right"></i>
    </div>
    <div class="pagination-side-icon" (click)="pagination.has_next_page ? setCurrentPage(pagination.last_page) : $event.stopPropagation()">
      <i class="fa fa-lg fa-angle-double-right"></i>
    </div>
  </div>
</form>